import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import CustomCheckbox from '../../../../../commonComponents/forms/inputs/CustomCheckbox';
import ProductVariationsProp from '../../../propTypes/productVariationsProp';
import translate from '../../../../../commonComponents/translate';
import FormInput from '../../../../../commonComponents/forms/FormInput';

function PackItem(props) {
  const { t, variation, onClick, onChange, stock, sectionId, isBySection } =
    props;
  const {
    name: variationName,
    parentProductName,
    icon,
    lowStockWarning,
    stockQuantity,
    quantity,
    restockInterval,
    restockDate,
    locked,
  } = variation || {};

  const stockMessage = useMemo(() => {
    if (!stock?.[variation._id]) {
      let message = '';
      let date = null;
      if (restockDate) {
        date =
          new Date().getTime() > new Date(restockDate).getTime()
            ? null
            : moment.utc(restockDate).format('DD MMM, YY');
      }
      if (
        lowStockWarning &&
        stockQuantity &&
        lowStockWarning >= stockQuantity
      ) {
        message = t('shop.product.warning.message.lowStock');
      }
      if (stockQuantity === 0) {
        message = t('product.no.stock');
      }
      if (variation.stockQuantity && variation.stockQuantity < quantity) {
        const restockIntervalMsg = restockInterval
          ? t(
              'shop.product.warning.message.quantityAboveStock.interval',
              restockInterval,
            )
          : t('shop.product.warning.message.warning.noStock');
        // t('shop.product.warning.message.quantityAboveStock.noDateNoInterval');
        message = date
          ? t('shop.product.warning.message.quantityAboveStock.date', date)
          : restockIntervalMsg;
      }
      return message;
    }

    if (!stock[variation._id]?.stockQuantity) {
      return '';
    }

    if (isBySection) {
      return stock[variation._id]?.stockQuantity <
        (stock[variation._id]?.quantity ?? 0)
        ? t('product.no.stock')
        : '';
    }

    return stock[variation._id]?.stockQuantity <
      quantity + (stock[variation._id]?.quantity ?? 0)
      ? t('product.no.stock')
      : '';
  }, [variation, stock, isBySection]);
  const image = icon?.thumb;
  return (
    <div className="pack-item-wrapper" key={variation._id}>
      <CustomCheckbox
        id={`${variation._id}-${sectionId}`}
        checkedProp={variation.inside}
        onClick={() => onClick(variation, sectionId)}
        disabled={stockQuantity === 0 || locked}
      />
      <div className="image-container">
        <img src={image} alt={variationName} />
      </div>
      <div className="name-wrapper">
        <h5 className="parentProductName">{parentProductName}</h5>
        <p className="variationName">{variationName}</p>
        {stockMessage?.length > 0 ? (
          <p className="stock">{stockMessage}</p>
        ) : null}
      </div>
      <div className="quantity-wrapper">
        <FormInput
          id="quantity"
          type="number"
          name="quantity"
          disabled={stockQuantity === 0 || locked}
          groupProps={{ skipWrapper: true }}
          value={variation?.quantity || 0}
          onChange={value => onChange(variation._id, sectionId)(value)}
          inputProps={{
            min: 0,
          }}
        />
      </div>
    </div>
  );
}

PackItem.propTypes = {
  t: PropTypes.func.isRequired,
  variation: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  stock: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      stockQuantity: PropTypes.number,
      quantity: PropTypes.number,
    }),
  }),
  sectionId: PropTypes.string,
  isBySection: PropTypes.bool,
};
PackItem.defaultProps = {
  stock: null,
  sectionId: null,
  isBySection: false,
};

export default translate(PackItem);
